import BalanceComponent from '../components/balance/balance.jsx'

const Balance = () => <BalanceComponent />

export default Balance;